import { RANGE_FORCASTING_DATA, GET_SIMULATION, GET_FMU, GET_FCMT } from '../actions/actionTypes';

const initialState = [];

export const rangeForcasting_Reducer = (state = initialState, action) => {
    switch (action.type) {
        case RANGE_FORCASTING_DATA: {
            const range_data = Object.assign({}, state, action.config);
            return range_data;
        }
        case GET_SIMULATION: {
            const simulationdetails = Object.assign({}, state, { simulation: action.payload });
            return simulationdetails;
        }
        case GET_FMU: {
            const FMUdetails = Object.assign({}, state, { FMU: action.payload });
            return FMUdetails;
        }
        case GET_FCMT: {
            const FCMTdetails = Object.assign({}, state, { FCMT: action.payload });
            return FCMTdetails;
        }
        default: {
            return state;
        }
    }
}